import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddEditMetaCustomAudienceModal = React.lazy(
  () => import("./add-edit-meta-custom-audience.modal"),
);

const AddEditMetaCustomAudience: iModalProps<
  typeof AddEditMetaCustomAudienceModal,
  {
    audienceId?: string;
    onSaved?: () => void;
  }
> = {
  name: "add-edit-meta-custom-audience",
  component: GenerateModalWithSuspense(AddEditMetaCustomAudienceModal),
};

export default AddEditMetaCustomAudience;
